<template lang="pug">
  v-dialog(v-model='dialog', max-width="600px" persistent)
    template(v-slot:activator='{ on }')
      v-list-tile(v-on='on')
        v-list-tile-title {{ $t('buttons.edit') }}
    v-card(grid-list-md)
      v-toolbar(dark, height="45" color='primary')
        v-btn(icon, dark, @click='close()')
          v-icon close
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.editAppeal') }}
      v-card-text
        v-container(grid-list-lg)
          v-layout(row wrap)
            v-flex(xs12)
              v-layout(row wrap) 
                v-flex(xs12 sm4)
                  DateTimePicker(:showIcon="false"
                    :range="false"
                    :clearable="false"
                    :hideTime="true"
                    label="Invoice Date"
                    v-on:input="setDueDate" 
                    :initStartDate="$moment(new Date())" 
                    :noFuture="true")
                v-flex(xs12 sm4)
                  v-text-field(v-model="appeal.phoneNumber" label='Phone Number')  
                v-flex(xs12 sm4)
                  v-select(
                    :items="comboBoxByID(25).ComboBoxDetails"
                    :label="$t('labels.saleType')"
                    item-text="selector"
                    item-value="id" 
                    v-model="appeal.saleTypeID")
                v-flex(xs12 sm4)
                  v-select(
                    :items="comboBoxByID(26).ComboBoxDetails"
                    :label="$t('labels.status')"
                    item-text="selector"
                    item-value="id" 
                    v-model="appeal.statusID")
                v-flex(xs12 sm8)
                  v-text-field(v-model="appeal.phoneName" label='Phone Name')  
                v-flex(xs12 sm6)
                  v-text-field(v-model="appeal.IMEINumber" label='IMEI Number')  
                v-flex(xs12 sm6)
                  v-text-field(v-model="appeal.additionalIMEINumber" label='Additional IMEI Number')  
                v-flex(xs12 sm6)
                  v-combobox(
                    :items="comboBoxByID(27).ComboBoxDetails"
                    :label="$t('labels.appealFor')"
                    item-text="selector"
                    returnObject
                    v-model="appealFor")
                v-flex(xs12 sm6)
                  v-text-field.right-input(v-model="appeal.amount" label='Amount')  
                
      v-card-actions
        v-spacer
        v-btn(color='info', flat, @click='close()') Close
        v-btn(color='info' dark @click='update()') Save
      
</template>

<script>
import { mapGetters } from "vuex";
import AppealService from "../service.js";
import DateTimePicker from "../../../Global/components/DateTimePicker";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    editValue: {
      default: null
    },
  },
  name: "create-reconcile",
  data() {
    return {
      id: null,
      dialog: false,
      appealFor: null,
      appeal: {
        invoiceDate: new Date(),
        phoneNumber: null,
        saleTypeID: 37,
        statusID: null,
        phoneName: null,
        IMEINumber: null,
        additionalIMEINumber: null,
        amount: 0
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    appeal: {
      phoneName: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBoxByID", "currentUser"]),
    ...mapGetters("location", ["location"]),
    feeErrors() {
      const errors = [];
      if (!this.$v.reconcile.fee.$dirty) return errors;
      if (!this.$v.reconcile.fee.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  components: {
    DateTimePicker
  },
  watch: {
    dialog(val) {
      if (val) {
        this.appealFor = this.editValue.appealFor
        this.id = this.editValue.id
        this.appeal = {
          invoiceDate: this.editValue.invoiceDate,
          phoneNumber: this.editValue.phoneNumber,
          statusID: this.editValue.statusID,
          saleTypeID: this.editValue.saleTypeID,
          phoneName: this.editValue.phoneName,
          IMEINumber: this.editValue.IMEINumber,
          additionalIMEINumber: this.editValue.additionalIMEINumber,
          amount: this.editValue.amount
        }
      }
    }
  },
  methods: {
    empty() {
      this.appealFor = null
      this.id = null
      this.appeal = {
        invoiceDate: new Date(),
        phoneNumber: null,
        saleTypeID: 37,
        phoneName: null,
        IMEINumber: null,
        additionalIMEINumber: null,
        amount: 0
      }
    },
    setDueDate(val) {
      this.appeal.invoiceDate = val;
    },
    close() {
      this.empty()
      this.dialog = false
    },
    update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.appeal.storeID = this.location.storeID
        this.appeal.organizationID = this.location.Organization.organizationID
        this.appeal.appealFor = this.appealFor.selector
        console.log('appealFor', this.appealFor)
        AppealService.update(this.id, this.appeal)
        .then(result => {
          this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: "success",
            title: "Reconcile Service is started"
          });
          this.close()
          this.$emit("created");
        });
      }
    }
  }
}
</script>
<style scoped>
  .v-dialog__container {
    display: none !important;
  }
</style>
